'use strict';

function markdownLineEndingOrSpace(code) {
  return code < 0 || code === 32;
}
module.exports = markdownLineEndingOrSpace;